import { render } from "./ContractRegistrationList.vue?vue&type=template&id=0354ff38"
import script from "./ContractRegistrationList.vue?vue&type=script&lang=js"
export * from "./ContractRegistrationList.vue?vue&type=script&lang=js"

import "./ContractRegistrationList.vue?vue&type=style&index=0&id=0354ff38&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__